import userService from "@/endpoints/userService";
import ShowToaster from "@/toaster";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateMarketColor = createAsyncThunk<
  { marketId: number; color: string } | null,
  { marketId: number; userId: number; color: string },
  { rejectValue: string }
>("markets/updateColor", async ({ color, marketId, userId }, thunkAPI) => {
  try {
    const response: string = (await userService.markets.updateMarketColor({
      userId,
      marketId,
      color,
    })) as any;
    return response ? { marketId, color } : null;
  } catch (err: any) {
    ShowToaster.error("Failed to update market color.");
    return thunkAPI.rejectWithValue(
      "Failed to update market color. " + err.message
    );
  }
});
